<!-- TOP Nav Bar -->
<div class="iq-top-navbar header-top-sticky">
  <div class="iq-navbar-custom">
    <nav class="navbar navbar-expand-lg  p-0">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="ri-menu-3-line"></i>
      </button>
      <div class="iq-menu-bt align-self-center">
        <div class="wrapper-menu" role="button" tabindex="0" aria-label="Toggle navigation menu"
          (keydown.enter)="$any($event.target).click()" (keydown.space)="$event.preventDefault(); $any($event.target).click()">
          <div class="main-circle"><i class="ri-menu-3-line"></i></div>
          <div class="hover-circle"><i class="ri-close-line"></i></div>
        </div>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto navbar-list">
          <ng-container *ngIf="tempFeatured">
            <ng-container *ngIf="tempFeatured.canNotifyCustomers">
              <li class="nav-item" (click)="openDialog()">
                <a class="search-toggle iq-waves-effect cp">
                  <i class="fa fa-share-square-o"></i>
                </a>
              </li>
            </ng-container>
          </ng-container>
          <li class="nav-item" (click)="goToChatListing()">
            <a class="search-toggle iq-waves-effect">
              <i class="fa fa-comments-o"></i>
            </a>
          </li>
          <app-notifications></app-notifications>
        </ul>
      </div>
      <ul class="navbar-list">
        <li class="nav-item">
          <div class="down_icon"></div>
        </li>
      </ul>
      <ul class="navbar-list">
        <li>
          <a class="search-toggle iq-waves-effect d-flex align-items-center cp">
            <div class="caption">
              <h6 class="mb-0 line-height text-white">{{this.user.firstName}}</h6>
            </div>
            <img [src]="this.user.photoUrl" class="img-fluid rounded ml-3" alt="user">
          </a>
          <div class="iq-sub-dropdown iq-user-dropdown">
            <div class="iq-card shadow-none m-0">
              <div class="iq-card-body p-0 ">
                <div class="bg-primary p-3">
                  <h5 class="mb-0 text-white line-height">Hello {{this.user.firstName}}</h5>
                </div>
                <a routerLink="/account/profile" class="iq-sub-card iq-bg-primary-hover">
                  <div class="media align-items-center">
                    <div class="rounded iq-card-icon iq-bg-primary">
                      <i class="ri-profile-line"></i>
                    </div>
                    <div class="media-body ml-3">
                      <h6 class="mb-0 ">Edit Profile</h6>
                      <p class="mb-0 font-size-12">Modify your personal details.</p>
                    </div>
                  </div>
                </a>
                <a routerLink="/account/change-password" class="iq-sub-card iq-bg-primary-hover">
                  <div class="media align-items-center">
                    <div class="rounded iq-card-icon iq-bg-primary">
                      <i class="ri-lock-password-line"></i>
                    </div>
                    <div class="media-body ml-3">
                      <h6 class="mb-0 ">Change Password</h6>
                      <p class="mb-0 font-size-12">Change your account password.</p>
                    </div>
                  </div>
                </a>
                <div class="d-inline-block w-100 text-center p-3">
                  <button type="button" class="bg-primary iq-sign-btn" (click)="logout()">
                    Log out<i class="ri-login-box-line ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</div>
